import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface accountMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allAccountList: any[];
}

const initialState: accountMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allAccountList: [],
};

export const accountMasterSlice = createSlice({
  name: 'accountMaster',
  initialState,
  reducers: {
    setAccountMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAccountBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllAccountMaster: (state, action) => {
      state.allAccountList = action.payload.data;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setAccountMaster, setAccountBySearch, reset, setAllAccountMaster } = accountMasterSlice.actions;
export const getAccountMasterDetails = (state: RootState) => state.accountMaster.data;
export const getAccountDetailsBySearch = (state: RootState) => state.accountMaster.data;
export const getAccountMasterTotalRecords = (state: RootState) => state.accountMaster.totalRecords;
export const getAllAccountMasterList = (state: RootState) => state.accountMaster.allAccountList;
export const getAccountMasterListWithAll = (state: RootState) => [
  {
    id: 0,
    accountName: "ALL",
    description: "All Accounts",
    isActive: true,
  },
  ...(state.accountMaster.allAccountList || []),
];

export default accountMasterSlice.reducer;